import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import { COLOR_WHITE } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledModal = styled(Dialog)`
  &.MuiDialog-root {
    .MuiDialog-paper {
      border-radius: 1rem;
      max-width: 100%;
    }
  }
`;

export const StyledContainer = styled(Box)`
  ${flex({ fd: "column" })};
  width: 560px;
  padding: 1.5rem;
  row-gap: 1.5rem;
  background-color: ${COLOR_WHITE};
`;

export const StyledButtonsContainer = styled(Box)`
  ${flex({ jc: "flex-end", ai: "center" })};
  column-gap: 1rem;
`;
